<template>
    <div id="component_settings">
        <div class="h-screen bg-img-work-space no-gutter">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-8 flex flex-wrap justify-center">
                            <div class="w-full lg:w-3/4 xl:w-2/3 m-4">
                                <h1 class="text-center">Cài đặt chung</h1>
                                <div class="vx-card p-6 mt-5">
                                    <vs-tabs position="left" v-model="activeTab">
                                        <vs-tab label="Workspace">
                                            <div class="vx-row md:px-20">
                                                <div class="vx-col w-1/2">
                                                    <div class="vx-row">
                                                        <div class="vx-col w-full text-center mb-2">
                                                            <span
                                                                class="text-xl font-semibold">Workspace khả dụng</span>
                                                        </div>
                                                    </div>
                                                    <div class="table_workspace">
                                                        <draggable v-model="workspaceNotData"
                                                                   :options="dragOptions"
                                                                   group="people">
                                                            <div v-for="item in workspaceNotData" :key="item.order"
                                                                 class="cursor-pointer item_workspace">
                                                                <vs-list-item class="text-md font-semibold">{{
                                                                        item.name
                                                                    }}
                                                                </vs-list-item>
                                                            </div>
                                                        </draggable>
                                                    </div>
                                                </div>
                                                <div class="vx-col w-1/2">
                                                    <div class="vx-row">
                                                        <div class="vx-col w-full text-center mb-2">
                                                            <span class="text-xl font-semibold">Đang sử dụng</span>
                                                        </div>
                                                    </div>
                                                    <div class="table_workspace">
                                                        <draggable v-model="workspaceData"
                                                                   :options="dragOptions"
                                                                   group="people" disabled>
                                                            <div v-for="item in workspaceData" :key="item.order"
                                                                 class="cursor-pointer item_workspace">
                                                                <vs-list-item class="text-md font-semibold">{{
                                                                        item.name
                                                                    }}
                                                                </vs-list-item>
                                                            </div>
                                                        </draggable>
                                                    </div>
                                                </div>
                                                <div class="vx-col w-full mt-24">
                                                    <div class="float-right">
                                                        <vs-button class="mr-2" color="primary" @click="saveWorkspace">Lưu</vs-button>
                                                        <vs-button type="border" color="danger" @click="$router.go(-1)">Hủy</vs-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </vs-tab>
                                        <vs-tab label="Logo">
                                            <div>

                                            </div>
                                        </vs-tab>
                                    </vs-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    name: "Setting",

    components: {
        draggable,
    },

    data() {
        return {
            activeTab: 0,
            workspaceAllData: [],
            workspaceData: [],
            workspaceNotData: [],
            dragOptions: {
                animation: 200,
            },
        }
    },

    async created() {
        await this.getAllWorkspace();
        await this.getWorkspaceOrg();
        this.getWorkspaceNot();
    },

    methods: {
        getAllWorkspace() {
            return new Promise((resolve, reject) => {
                let payload = {
                    pageNumber: 0,
                    pageSize: 100,
                }
                this.$vs.loading();
                this.$crm.post('/setting/find-by-condition', payload).then(res => {
                    this.workspaceAllData = res.data.content;
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getWorkspaceOrg() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get('/setting/organization-workspace/find-by-organization-id').then(res => {
                    this.workspaceData = res.data.map(el => {
                        el.order = el.orders;
                        el.name = el.settingProjectWorkspace.nameIconApp;
                        el.fixed = false;
                        return el;
                    });
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getWorkspaceNot() {
            let order = 0;
            this.workspaceNotData = [];
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.workspaceAllData.forEach(el => {
                let workspace = this.workspaceData.find(x => x.settingProjectWorkspace.id === el.id);
                if (!workspace) {
                    let item = {
                        order: order + 1,
                        organizationId: userInfo.organization.id,
                        name: el.nameIconApp,
                        fixed: false,
                        settingProjectWorkspace: el,
                    }
                    this.workspaceNotData.push(item)
                }
            })
        },

        saveWorkspace() {
            if (this.workspaceData.length === 0) {
                return this.$vs.notify({
                    text: `Không được để trống trường 'Đang sử dụng'!`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let payload = [];
            this.workspaceData.forEach(el => {
                payload.push(el.settingProjectWorkspace.id)
            })
            this.$vs.loading.close();

            this.$crm.post('/setting/organization-workspace/save', payload).then(() => {
                this.$vs.notify({
                    text: 'Cập nhật workspace thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$vs.loading.close();
                this.$router.go(-1);
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
    }
}
</script>

<style lang="scss">
#component_settings {

    .bg-img-work-space {
        background-image: url("../../../assets/images/pages/background-light.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .work_space_app {
        text-align: -webkit-center;
        cursor: pointer;

        .backround_icon_app {
            display: flex;
            padding: 10px;
            border-radius: 6px;
            background: #FFF;
            width: 70px;
            height: 70px;
            margin-bottom: 0.5rem;

            &:hover {
                transition: all 0.2s ease-out;
                box-shadow: rgba(0, 0, 0, 0.25) 0 14px 28px, rgba(0, 0, 0, 0.22) 0 10px 10px;
                top: -10px;
            }

            .icon_app {
                width: 50px;
                height: 50px;
            }
        }
    }

    .add_work_space_app {
        text-align: -webkit-center;
        cursor: pointer;

        .background_add {
            background-color: #FFFFFF;
            width: 70px;
            height: 70px;
            border: dashed 2px rgba(var(--vs-primary), 1);
            border-radius: 6px;

            &:hover {
                transition: all 0.2s ease-out;
                box-shadow: rgba(0, 0, 0, 0.25) 0 14px 28px, rgba(0, 0, 0, 0.22) 0 10px 10px;
                top: -10px;
            }
        }
    }

    .table_workspace {
        border: 1px solid #dbdade;
        border-radius: 0.375rem;
        padding: 0.75rem;
    }

    .item_workspace {
        border: 1px solid #dbdade;
        border-radius: 0.375rem;
        margin-top: 0.3rem;
    }

    .vs-list--slot {
        margin-left: inherit !important;
    }
}
</style>
